import React, { Component } from 'react';
import moment from 'moment'
import CustomerReports from '../presentation/customer-reports';

class CustomerReportsWidget extends Component {
    state = {
        projects: [] 
    }
 
    componentWillMount() {
        const accountId = this.props.id
        this.loadProjectsFromServer(accountId)
    }

    loadProjectsFromServer(accountId) {
        fetch(`/service/${accountId}/projects`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin'
        }).then(response => {
            if (response.status != 200) {
                response.json().then(json => this.handleError(json, this));
            } else {
                response.json().then(projects => this.setState({ projects }))
            }
        });
    }

   postCsvRequest = (startTime, endTime, projectId) => {
        const body = {
            projectId,
            startTime,
            endTime,
            timeType: "creationTime",
            format: "csv"
        }
        
        return fetch(`${process.env.ANALYTICS_URL}/checkins/_search`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin',
            body: JSON.stringify(body)
        })
    }

    generateCsvReport = (fromDate, toDate, projectIdList) => {
        const startTime = new Date(moment.utc(fromDate).startOf('day')).toISOString()
        const endTime = new Date(moment.utc(toDate).endOf('day')).toISOString()

        const csvRequestsPromises = projectIdList.map(projectId => this.postCsvRequest(startTime, endTime, projectId))

        Promise.all(csvRequestsPromises)
            .then((successRequets) => console.log(successRequets))
            .catch(error => console.error(`Error on at least one of the CSV Requests to Analytics API: ${error}`))
    }

    render() {
        return <CustomerReports 
                    projects={this.state.projects}
                    generateCsvReport={this.generateCsvReport}
                />
    } // render
}; // CustomerReportsWidget


export default CustomerReportsWidget;